import { render, staticRenderFns } from "./ScrollTrigger.vue?vue&type=template&id=46e81ab4"
import script from "./ScrollTrigger.vue?vue&type=script&lang=js"
export * from "./ScrollTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports